import {motion} from "framer-motion";
import React, {useEffect, useState} from "react";
import {typeQubes} from "./BaseItem";
import styled, { keyframes, css } from 'styled-components';
import cadr1 from '../../assets/bomb/cadr_1.png';
import cadr2 from '../../assets/bomb/cadr_2.png';
import cadr3 from '../../assets/bomb/cadr_3.png';
import cadr4 from '../../assets/bomb/cadr_4.png';
import cadr5 from '../../assets/bomb/cadr_5.png';
import cadr6 from '../../assets/bomb/cadr_6.png';
import cadr7 from '../../assets/bomb/cadr_7.png';
import cadr8 from '../../assets/bomb/cadr_8.png';
import cadr9 from '../../assets/bomb/cadr_9.png';
import cadr10 from '../../assets/bomb/cadr_10.png';
import cadr11 from '../../assets/bomb/cadr_11.png';
import cadr12 from '../../assets/bomb/cadr_12.png';
import cadr13 from '../../assets/bomb/cadr_13.png';
import cadr14 from '../../assets/bomb/cadr_14.png';
import cadr15 from '../../assets/bomb/cadr_15.png';
import cadr16 from '../../assets/bomb/cadr_16.png';
import cadr17 from '../../assets/bomb/cadr_17.png';
import cadr18 from '../../assets/bomb/cadr_18.png';

import cadrbomb1 from '../../assets/bomb/bombAnimation/1.png';
import cadrbomb2 from '../../assets/bomb/bombAnimation/2.png';
import cadrbomb3 from '../../assets/bomb/bombAnimation/3.png';
import cadrbomb4 from '../../assets/bomb/bombAnimation/4.png';
import cadrbomb5 from '../../assets/bomb/bombAnimation/5.png';
import cadrbomb6 from '../../assets/bomb/bombAnimation/6.png';
import cadrbomb7 from '../../assets/bomb/bombAnimation/7.png';
import cadrbomb8 from '../../assets/bomb/bombAnimation/8.png';
import cadrbomb9 from '../../assets/bomb/bombAnimation/9.png';
import {eventEmitter} from "../../EventEmitter";

interface Props {
    size: number;
    isDisappearance?: boolean
    movesLeft?: number;
}

const framesBomb = [
    cadrbomb1, cadrbomb2, cadrbomb3, cadrbomb4, cadrbomb5, cadrbomb6, cadrbomb7, cadrbomb8, cadrbomb9
];

const frames = [
    cadr1, cadr2, cadr3, cadr4, cadr5, cadr6, cadr7, cadr8, cadr9, cadr10,
    cadr11, cadr12, cadr13, cadr14, cadr15, cadr16, cadr17, cadr18
];

const bombAnimation = keyframes`
    0% { background-image: url(${cadrbomb1}); }
    12.5% { background-image: url(${cadrbomb2}); }
    25% { background-image: url(${cadrbomb3}); }
    37.5% { background-image: url(${cadrbomb4}); }
    50% { background-image: url(${cadrbomb5}); }
    62.5% { background-image: url(${cadrbomb6}); }
    75% { background-image: url(${cadrbomb7}); }
    87.5% { background-image: url(${cadrbomb8}); }
    100% { background-image: url(${cadrbomb9}); }
`;

const bombReverseAnimation = keyframes`
    0% { background-image: url(${cadrbomb9}); }
    12.5% { background-image: url(${cadrbomb8}); }
    25% { background-image: url(${cadrbomb7}); }
    37.5% { background-image: url(${cadrbomb6}); }
    50% { background-image: url(${cadrbomb5}); }
    62.5% { background-image: url(${cadrbomb4}); }
    75% { background-image: url(${cadrbomb3}); }
    87.5% { background-image: url(${cadrbomb2}); }
    100% { background-image: url(${cadrbomb1}); }
`;

const explosionAnimation = keyframes`
    0% { background-image: url(${cadr1}); }
    5.56% { background-image: url(${cadr2}); }
    11.12% { background-image: url(${cadr3}); }
    16.68% { background-image: url(${cadr4}); }
    22.24% { background-image: url(${cadr5}); }
    27.8% { background-image: url(${cadr6}); }
    33.36% { background-image: url(${cadr7}); }
    38.92% { background-image: url(${cadr8}); }
    44.48% { background-image: url(${cadr9}); }
    50.04% { background-image: url(${cadr10}); }
    55.6% { background-image: url(${cadr11}); }
    61.16% { background-image: url(${cadr12}); }
    66.72% { background-image: url(${cadr13}); }
    72.28% { background-image: url(${cadr14}); }
    77.84% { background-image: url(${cadr15}); }
    83.4% { background-image: url(${cadr16}); }
    88.96% { background-image: url(${cadr17}); }
    100% { background-image: url(${cadr18}); }
`;

const scaleAnimation = keyframes`
    0%, 100% { transform: scale(1); }
    50% { transform: scale(0.95); }
`;

const BombContainer = styled.div`
    width: 100%;
    height: 100%;
    animation: ${scaleAnimation} 2s infinite;
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
`;

const Bomba = styled.div<{size: number; movesLeft: number}>`
    width: 115%;
    height: 115%;
    background-size: contain;
    background-position: center;
    top: 40%;
    left: 50%;
    transform: translate(-50%, -50%);
    position: absolute;
    background-repeat: no-repeat;
    display: flex;
    align-items: center;
    filter: ${({movesLeft}) => movesLeft <= 3 ? 'drop-shadow(0px 0px 6px red)' : 'drop-shadow(0px 0px 6px white)'};
    animation: ${bombAnimation} 1s steps(${framesBomb.length}) infinite alternate, ${bombReverseAnimation} 1s steps(${framesBomb.length}) infinite alternate;
`;

const Text = styled.div`
    position: absolute;
    color: yellow;
    font-weight: 900;
    font-size: 12px;
    left: 50%;
    top: 70%;
    transform: translate(-50%, -50%);
    
    @media (min-width: 768px) {
        font-size: 18px;
    }
`;

const Explosion = styled.div<{ animate: boolean }>`
    width: 400%;
    height: 400%;
    background-size: contain;
    background-position: center;
    position: absolute;
    background-repeat: no-repeat;
    ${({ animate }) =>
    animate &&
    css`
            animation: ${explosionAnimation} 1s steps(${frames.length}) infinite;
        `}
`;

export const Bomb = ({size, isDisappearance = false, movesLeft = 9}: Props) => {
    const [explosion, setExplosion] = useState(false);

    useEffect(() => {
        if (!movesLeft) {
            setTimeout(() => {
                eventEmitter.emit('game_over_by_bomb', {});
            }, 300)
        }
    }, [])

    useEffect(() => {
        if (isDisappearance) {
            setExplosion(true);
        }
    }, [isDisappearance])

    return <BombContainer>
        {!explosion && <Bomba movesLeft={movesLeft} size={size}>
            <Text>{movesLeft}</Text>
        </Bomba>}
        {explosion && <Explosion animate />}
    </BombContainer>;
}